import { AssignmentStatus } from '../AssignmentHelpers/types'

export interface ApprovalProps {
  approvalName?: string
  approvalStatus: ApprovalStatus
  assignmentStatus: AssignmentStatus
  commentText?: string
  completedAt?: Date
  contextLiveDate: Date
  contextName: string
  dueDate?: Date
  hardDueDate: boolean
  iconColor: string
  iconName: string
  onItemClick: React.MouseEventHandler<HTMLElement>
  overdue?: boolean
}

export enum ApprovalStatus {
  complete = 'Approved',
  rejected = 'Declined',
  incomplete = 'Pending',
}
